import React, { useEffect, useState } from 'react'
import { Form, Modal } from 'semantic-ui-react'
import { FlexRowBetween, TitleText } from 'components'
import { AppButton, AppPrimaryButton } from 'elements'
import { X } from 'phosphor-react'

export const TestSendModal = ({
    open,
    onClose,
    onConfirm,
    loading,
    adminEmail,
    error,
}) => (
    <Modal open={open} onClose={loading ? undefined : onClose} size="small">
        <Modal.Header>
            <FlexRowBetween>
                <TitleText>Send test email</TitleText>
                <X
                    size={20}
                    style={{ cursor: loading ? 'default' : 'pointer' }}
                    onClick={loading ? undefined : onClose}
                />
            </FlexRowBetween>
        </Modal.Header>
        <Modal.Content>
            {error && <div className="error-text mb-2">{error}</div>}
            <p>
                This will render the digest using the schedule&apos;s current
                filters and last-window rules, then email it to{' '}
                <strong>{adminEmail || 'your email'}</strong> only. Real
                recipients are not notified.
            </p>
            <div
                style={{
                    padding: 12,
                    background: '#eff6ff',
                    border: '1px solid #bfdbfe',
                    borderRadius: 6,
                    color: '#1e40af',
                    fontSize: 12.5,
                    marginTop: 12,
                }}
            >
                Test emails log a Run row with Trigger=Test — visible in Run
                History only to you.
            </div>
        </Modal.Content>
        <Modal.Actions>
            <AppButton onClick={onClose} disabled={loading}>
                Cancel
            </AppButton>
            <AppPrimaryButton onClick={onConfirm} loading={loading}>
                Send test email
            </AppPrimaryButton>
        </Modal.Actions>
    </Modal>
)

export const DeleteScheduleModal = ({
    open,
    onClose,
    onConfirm,
    loading,
    scheduleName,
    error,
}) => {
    const [confirmName, setConfirmName] = useState('')

    useEffect(() => {
        if (open) setConfirmName('')
    }, [open])

    const handleClose = () => {
        setConfirmName('')
        onClose()
    }

    const canDelete =
        confirmName.trim().toLowerCase() ===
        (scheduleName || '').trim().toLowerCase()

    return (
        <Modal open={open} onClose={loading ? undefined : handleClose} size="small">
            <Modal.Header>
                <FlexRowBetween>
                    <TitleText style={{ color: '#dc2626' }}>
                        Delete this schedule?
                    </TitleText>
                    <X
                        size={20}
                        style={{ cursor: loading ? 'default' : 'pointer' }}
                        onClick={loading ? undefined : handleClose}
                    />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                {error && <div className="error-text mb-2">{error}</div>}
                <p>
                    You&apos;re about to soft-delete{' '}
                    <strong>{scheduleName}</strong>. It will disappear from the
                    list, and no more digests will be sent.
                </p>
                <div
                    style={{
                        padding: 12,
                        background: '#eff6ff',
                        border: '1px solid #bfdbfe',
                        borderRadius: 6,
                        color: '#1e40af',
                        fontSize: 12.5,
                        margin: '12px 0',
                    }}
                >
                    Run history is preserved — you can find past fires by
                    filtering the Run History card with the schedule name.
                </div>
                <Form>
                    <Form.Field>
                        <label>To confirm, type the schedule name below:</label>
                        <Form.Input
                            placeholder={scheduleName}
                            value={confirmName}
                            onChange={(_, { value }) => setConfirmName(value)}
                            disabled={loading}
                        />
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <AppButton onClick={handleClose} disabled={loading}>
                    Cancel
                </AppButton>
                <AppButton
                    negative
                    onClick={onConfirm}
                    loading={loading}
                    disabled={!canDelete}
                >
                    Delete schedule
                </AppButton>
            </Modal.Actions>
        </Modal>
    )
}
